import { render, staticRenderFns } from "./Obi404.vue?vue&type=template&id=aa2fbfb0&scoped=true&"
import script from "./Obi404.vue?vue&type=script&lang=js&"
export * from "./Obi404.vue?vue&type=script&lang=js&"
import style0 from "./Obi404.vue?vue&type=style&index=0&id=aa2fbfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2fbfb0",
  null
  
)

export default component.exports